const doc = [({"ko":({"adminLabelHotelWaitingList":({"date":"날짜", "email":"이메일 주소", "hotelPlanName":"플랜명", "hotelRoomName":"방 타입명", "status":"상태"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;